<template>
  <div>
    <b-modal
      id="modal-btr"
      title="รายงานปฏิกิริยาจากการรับเลือด (BTR)"
      size="xl"
      hide-footer
      button-size="sm"
      :no-close-on-backdrop="true"
      :close-on-esc="true"
    >
      <b-alert
        show
        variant="dark"
        class="font14px icon-dark-custom margin-bottom"
      >
        <div>
          <b-alert
            show
            variant="primary"
            class="margin-bottom font18px jumbotron-custom2 font-color1"
          >
            <b-row v-if="this.PatientDataLoad">
              <b-col lg="3"> HN : {{ this.PatientDataLoad.hn }} </b-col>
              <b-col lg="4">
                ชื่อ-สกุล :
                {{
                  this.PatientDataLoad.datas.pname +
                    this.PatientDataLoad.datas.fname +
                    " " +
                    this.PatientDataLoad.datas.lname
                }}
              </b-col>
              <b-col lg="2">
                Type : {{ this.MyAn != "" ? "IPD" : "OPD" }}
              </b-col>
              <b-col lg="3"></b-col>
            </b-row>
            <b-row v-if="!this.AdmitDataLoad">
              <b-col lg="12">
                หน่วยงาน :
                {{ this.VisitDataLoad.datas.department_name }}
              </b-col>
            </b-row>
            <b-row v-if="this.AdmitDataLoad">
              <b-col lg="3"> AN : {{ this.AdmitDataLoad.datas.an }} </b-col>
              <b-col lg="9">
                Ward :
                {{ this.AdmitDataLoad.datas.ward_name }}
              </b-col>
            </b-row>
          </b-alert>
          <b-alert show variant="secondary" class="margin-bottom">
            <b-row>
              <b-col lg="12">
                <h5>รายงานปฏิกิริยาจากการรับเลือด (BTR)</h5>
              </b-col>
            </b-row>
            <b-row>
              <b-col lg="12">
                <h6 class="font-color3">
                  <strong>BTR ID: {{ btr_id }}</strong>
                </h6>
              </b-col>
            </b-row>
            <b-row>
              <b-col lg="6">
                <b-form-group
                  class="text-lg-right"
                  label="Donor No:"
                  label-for="donor-no"
                  label-cols-lg="3"
                  label-size="sm"
                >
                  <b-form-input
                    id="donor-no"
                    v-model="DonorNo"
                    size="sm"
                    :readonly="!this.btr_save_button"
                    :state="DonorNo != ''"
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col lg="3">
                <b-form-group
                  class="text-lg-right"
                  label="BI. Gr:"
                  label-for="bi-gr"
                  label-cols-lg="4"
                  label-size="sm"
                >
                  <b-form-select
                    id="bi-gr"
                    v-model="BiGrSelected"
                    :options="ChoiceBigr"
                    size="sm"
                    :disabled="!this.btr_save_button"
                    :state="BiGrSelected != ''"
                  ></b-form-select>
                </b-form-group>
              </b-col>
              <b-col lg="3">
                <b-form-group
                  class="text-lg-right"
                  label="Rh:"
                  label-for="rh"
                  label-cols-lg="4"
                  label-size="sm"
                >
                  <b-form-select
                    id="rh"
                    v-model="RhSelected"
                    :options="ChoiceRh"
                    size="sm"
                    :disabled="!this.btr_save_button"
                    :state="RhSelected != ''"
                  ></b-form-select>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col lg="6">
                <b-form-group
                  class="text-lg-right"
                  label="เวลาเริ่มให้เลือด:"
                  label-cols-lg="4"
                  label-size="sm"
                >
                  <date-picker
                    v-model="blood_start_date"
                    :lang="lang"
                    :first-day-of-week="1"
                    format="DD/MM/YYYY"
                    confirm
                    style="width:120px;"
                    :disabled="!this.btr_save_button"
                  ></date-picker>
                  <date-picker
                    v-model="blood_start_time"
                    lang="en"
                    type="time"
                    format="HH:mm"
                    placeholder="Select Time"
                    confirm
                    style="width:100px;"
                    :minute-step="1"
                    :disabled="!this.btr_save_button"
                  ></date-picker>
                </b-form-group>
              </b-col>
              <b-col lg="6">
                <b-form-group
                  class="text-lg-right"
                  label="เวลาที่เกิดอาการ:"
                  label-cols-lg="4"
                  label-size="sm"
                >
                  <date-picker
                    v-model="blood_stop_date"
                    :lang="lang"
                    :first-day-of-week="1"
                    format="DD/MM/YYYY"
                    confirm
                    style="width:120px;"
                    :disabled="!this.btr_save_button"
                  ></date-picker>
                  <date-picker
                    v-model="blood_stop_time"
                    lang="en"
                    type="time"
                    format="HH:mm"
                    placeholder="Select Time"
                    confirm
                    style="width:100px;"
                    :minute-step="1"
                    :disabled="!this.btr_save_button"
                  ></date-picker>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col lg="6">
                <b-form-group
                  class="text-lg-right"
                  label="อุณหภูมิก่อนให้เลือด (°C):"
                  label-for="temperature_start"
                  label-cols-lg="6"
                  label-size="sm"
                >
                  <b-form-input
                    id="temperature_start"
                    v-model="temperature_start"
                    size="sm"
                    type="number"
                    :readonly="!this.btr_save_button"
                    :state="temperature_start != ''"
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col lg="6">
                <b-form-group
                  class="text-lg-right"
                  label="อุณหภูมิเมื่อหยุดให้เลือด (°C):"
                  label-for="temperature_stop"
                  label-cols-lg="6"
                  label-size="sm"
                >
                  <b-form-input
                    id="temperature_stop"
                    v-model="temperature_stop"
                    size="sm"
                    type="number"
                    :readonly="!this.btr_save_button"
                    :state="temperature_stop != ''"
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col lg="4">
                <b-form-group
                  class="text-lg-right"
                  label="ปริมาณเลือดที่ให้ (ml):"
                  label-for="blood_value"
                  label-cols-lg="8"
                  label-size="sm"
                >
                  <b-form-input
                    id="blood_value"
                    v-model="bloodValue"
                    size="sm"
                    type="number"
                    :readonly="!this.btr_save_button"
                    :state="bloodValue != ''"
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col lg="12">
                <hr class="hr-custom" />
                <h6><strong>Symptom</strong></h6>
              </b-col>
            </b-row>
            <b-row>
              <b-col
                lg="4"
                v-for="item in this.ChoiceSymptom"
                v-bind:key="item.id"
              >
                <b-row class="checkbox-symptom-custom">
                  <b-col lg="auto">
                    <b-form-checkbox-group
                      id="checkbox-symptom"
                      v-model="selectedCheckboxSymptom"
                      name="checkbox-symptom"
                    >
                      <b-form-checkbox
                        :value="item.value"
                        :disabled="!btr_save_button"
                      >
                        {{ item.text }}
                      </b-form-checkbox>
                    </b-form-checkbox-group>
                  </b-col>
                  <b-col lg="7">
                    <b-form-input
                      :id="'other-text' + item.value"
                      size="sm"
                      v-if="item.other == 'Y'"
                      v-model="item.other_text"
                      :readonly="!btr_save_button"
                    ></b-form-input>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
            <b-row>
              <b-col lg="12">
                <hr class="hr-custom" />
                <b-form-group
                  class="text-lg-right"
                  label="Note:"
                  label-for="blood-note"
                  label-cols-lg="1"
                  label-size="sm"
                >
                  <b-form-input
                    id="blood-note"
                    size="sm"
                    v-model="btr_note"
                    :readonly="!this.btr_save_button"
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col lg="12">
                <div class="log-style">Log. {{ this.btr_user_log }}</div>
              </b-col>
            </b-row>
            <b-row v-if="this.btr_save_button">
              <b-col lg="12">
                <div class="d-block text-center">
                  <b-button
                    variant="success"
                    size="sm"
                    class="d-print-none"
                    @click="
                      submitBTR(MyHn, 'saveBTR', 'ยืนยันการบันทึกข้อมูล !')
                    "
                  >
                    (BTR) Save
                  </b-button>
                  &nbsp;
                  <b-button
                    size="sm"
                    class="d-print-none"
                    @click="$bvModal.hide('modal-btr')"
                    >Close</b-button
                  >
                  &nbsp;
                  <b-button
                    variant="danger"
                    size="sm"
                    class="float-right d-print-none"
                    @click="
                      submitDeleteBTR(btr_id, 'Delete', 'ยืนยันการลบข้อมูล !')
                    "
                    v-if="this.btr_id != 'new' && this.btr_save_button"
                    >ลบ</b-button
                  >
                </div>
              </b-col>
            </b-row>
          </b-alert>

          <b-alert
            :show="this.SelectDataBTR != null && this.SelectDataBTR != ''"
          >
            <b-row>
              <b-col lg="12">
                <h5>Lab Cross Matching</h5>
              </b-col>
            </b-row>
            <b-row>
              <b-col lg="6">
                <b-card
                  header="ตัวอย่างเลือดผู้ป่วยครั้งที่ (1)"
                  class="text-left margin-bottom"
                  bg-variant="dark"
                  text-variant="white"
                >
                  <div>
                    <b-row>
                      <b-col lg="6">
                        <b-form-group
                          class="text-lg-left"
                          label="2.1 BI. Gr:"
                          :label-for="'lab-bi-gr1'"
                          label-cols-lg="4"
                          label-size="sm"
                        >
                          <b-form-select
                            id="lab-bi-gr1"
                            v-model="BiGrL1Selected"
                            :options="ChoiceBigr"
                            size="sm"
                            :disabled="true"
                          ></b-form-select>
                        </b-form-group>
                      </b-col>
                      <b-col lg="6">
                        <b-form-group
                          class="text-lg-left"
                          label="2.1 Rh:"
                          label-for="lab-rh1"
                          label-cols-lg="4"
                          label-size="sm"
                        >
                          <b-form-select
                            id="rh"
                            v-model="RhL1Selected"
                            :options="ChoiceRh"
                            size="sm"
                            :disabled="true"
                          ></b-form-select>
                        </b-form-group>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col lg="12">
                        <b-form-group
                          class="text-lg-left"
                          label="2.2 DAT:"
                          label-for="lab-dat1"
                          label-cols-lg="2"
                          label-size="sm"
                        >
                          <b-form-select
                            id="lab-dat1"
                            v-model="DatL1Selected"
                            :options="ChoiceDat"
                            size="sm"
                            :disabled="true"
                          ></b-form-select>
                        </b-form-group>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col lg="12">
                        <b-form-group
                          class="text-lg-left"
                          label="2.3 IAT:"
                          label-for="lab-iat1"
                          label-cols-lg="2"
                          label-size="sm"
                        >
                          <b-form-select
                            id="lab-iat1"
                            v-model="IatL1Selected"
                            :options="ChoiceIat"
                            size="sm"
                            :disabled="true"
                          ></b-form-select>
                        </b-form-group>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col lg="12">
                        <b-alert show variant="warning" class="margin-bottom">
                          <b-form-group
                            class="text-lg-left margin-bottom-0"
                            label="ผล Cross Matching :"
                            label-for="lab-cross-matching1"
                            label-cols-lg="4"
                            label-size="sm"
                          >
                            <b-form-select
                              id="lab-cross-matching1"
                              v-model="CrossMatchingL1Selected"
                              :options="ChoiceCrossMatching"
                              size="sm"
                              :disabled="true"
                            ></b-form-select>
                          </b-form-group>
                        </b-alert>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col lg="12">
                        <b-form-group
                          class="text-lg-left"
                          label="Note :"
                          label-for="lab-note1"
                          label-cols-lg="2"
                          label-size="sm"
                        >
                          <b-form-input
                            id="lab-note1"
                            size="sm"
                            v-model="NoteL1Selected"
                            :readonly="true"
                          ></b-form-input>
                        </b-form-group>
                      </b-col>
                    </b-row>
                  </div>
                </b-card>
              </b-col>

              <b-col lg="6">
                <b-card
                  header="ตัวอย่างเลือดผู้ป่วยครั้งที่ (2)"
                  class="text-left margin-bottom"
                  bg-variant="dark"
                  text-variant="white"
                >
                  <div>
                    <b-row>
                      <b-col lg="6">
                        <b-form-group
                          class="text-lg-left"
                          label="2.1 BI. Gr:"
                          :label-for="'lab-bi-gr2'"
                          label-cols-lg="4"
                          label-size="sm"
                        >
                          <b-form-select
                            id="lab-bi-gr2"
                            v-model="BiGrL2Selected"
                            :options="ChoiceBigr"
                            size="sm"
                            :disabled="true"
                          ></b-form-select>
                        </b-form-group>
                      </b-col>
                      <b-col lg="6">
                        <b-form-group
                          class="text-lg-left"
                          label="2.1 Rh:"
                          label-for="lab-rh2"
                          label-cols-lg="4"
                          label-size="sm"
                        >
                          <b-form-select
                            id="lab-rh2"
                            v-model="RhL2Selected"
                            :options="ChoiceRh"
                            size="sm"
                            :disabled="true"
                          ></b-form-select>
                        </b-form-group>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col lg="12">
                        <b-form-group
                          class="text-lg-left"
                          label="2.2 DAT:"
                          label-for="lab-dat2"
                          label-cols-lg="2"
                          label-size="sm"
                        >
                          <b-form-select
                            id="lab-dat2"
                            v-model="DatL2Selected"
                            :options="ChoiceDat"
                            size="sm"
                            :disabled="true"
                          ></b-form-select>
                        </b-form-group>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col lg="12">
                        <b-form-group
                          class="text-lg-left"
                          label="2.3 IAT:"
                          label-for="lab-iat2"
                          label-cols-lg="2"
                          label-size="sm"
                        >
                          <b-form-select
                            id="lab-iat2"
                            v-model="IatL2Selected"
                            :options="ChoiceIat"
                            size="sm"
                            :disabled="true"
                          ></b-form-select>
                        </b-form-group>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col lg="12">
                        <b-alert show variant="warning" class="margin-bottom">
                          <b-form-group
                            class="text-lg-left margin-bottom-0"
                            label="ผล Cross Matching :"
                            label-for="lab-cross-matching2"
                            label-cols-lg="4"
                            label-size="sm"
                          >
                            <b-form-select
                              id="lab-cross-matching2"
                              v-model="CrossMatchingL2Selected"
                              :options="ChoiceCrossMatching"
                              size="sm"
                              :disabled="true"
                            ></b-form-select>
                          </b-form-group>
                        </b-alert>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col lg="12">
                        <b-form-group
                          class="text-lg-left"
                          label="Note :"
                          label-for="lab-note2"
                          label-cols-lg="2"
                          label-size="sm"
                        >
                          <b-form-input
                            id="lab-note2"
                            size="sm"
                            v-model="NoteL2Selected"
                            :readonly="true"
                          ></b-form-input>
                        </b-form-group>
                      </b-col>
                    </b-row>
                  </div>
                </b-card>
              </b-col>
            </b-row>
            <b-alert
              show
              variant="light"
              class="margin-bottom font-color-black"
            >
              <b-row>
                <b-col lg="4">
                  <b-form-checkbox
                    id="labReceiveStatus1"
                    v-model="labReceiveStatus"
                    name="labReceiveStatus1"
                    value="Y"
                    unchecked-value="N"
                    :disabled="true"
                  >
                    Recive Order
                  </b-form-checkbox>
                </b-col>
                <b-col lg="4">
                  <b-form-checkbox
                    id="btrLabConfirm1"
                    v-model="btrLabConfirm"
                    name="btrLabConfirm1"
                    value="Y"
                    unchecked-value="N"
                    :disabled="true"
                  >
                    Confirm Cross Matching
                  </b-form-checkbox>
                </b-col>
              </b-row>
            </b-alert>
            <b-row>
              <b-col lg="12">
                <div class="log-style">Log. {{ this.btr_user_log }}</div>
              </b-col>
            </b-row>
            <b-row>
              <b-col lg="12">
                <div class="d-block text-center">
                  <b-button
                    size="sm"
                    class="d-print-none"
                    @click="$bvModal.hide('modal-btr')"
                    >Close</b-button
                  >
                </div>
              </b-col>
            </b-row>
          </b-alert>
        </div>
      </b-alert>
    </b-modal>

    <div>
      <b-button
        v-show="false"
        id="bt-btr-add"
        size="sm"
        variant="info"
        class="d-print-none"
        @click="selectItemBTR('new', MyHn, MyVn)"
        >เพิ่มรายงานปฏิกิริยาจากการรับเลือด</b-button
      >
    </div>

    <b-alert
      :show="this.tbBtrTableData && this.tbBtrTableData.length > 0"
      variant="dark"
      class="pj_clearfix margin-bottom"
    >
      <div>
        <h4>Blood transfusion reaction</h4>
        <b-alert show variant="light" class="pj_clearfix">
          <b-table
            striped
            hover
            small
            :items="this.tbBtrTableData"
            :fields="this.tbBtrTableFieldsData"
            :sort-by.sync="sortBy"
            :sort-asc.sync="sortDesc"
            class="font13px"
            responsive
          >
            <template v-slot:cell(lab_receive_status)="row">
              <v-icon
                name="shield-off"
                class="icon-custom1 font-color3"
                v-if="row.item.lab_receive_status == 'N'"
                v-b-tooltip.hover="'Waiting Lab Receive'"
              ></v-icon>
              <v-icon
                name="shield"
                class="icon-custom1 font-color2"
                v-if="row.item.lab_receive_status == 'Y'"
                v-b-tooltip.hover="'Lab Receive Success'"
              ></v-icon>
            </template>
            <template v-slot:cell(lab_cross_matching_status)="row">
              <v-icon
                name="sunset"
                class="icon-custom1 font-color3"
                v-if="row.item.lab_cross_matching_status == 'N'"
                v-b-tooltip.hover="'Waiting Lab Cross Matching'"
              ></v-icon>
              <v-icon
                name="sunrise"
                class="icon-custom1 font-color2"
                v-if="row.item.lab_cross_matching_status == 'Y'"
                v-b-tooltip.hover="'Lab Cross Matching Success'"
              ></v-icon>
            </template>
            <template v-slot:cell(actions)="row">
              <div
                @click="
                  selectItemBTR(row.item.btr_id, row.item.hn, row.item.vn)
                "
                v-if="row.item.btr_status != 'N'"
              >
                <v-icon
                  name="file-text"
                  class="icon-custom1 cursor-pointer font-color2"
                ></v-icon>
              </div>
              <div v-if="row.item.btr_status == 'N'">
                <v-icon
                  name="delete"
                  class="icon-custom1 cursor-pointer font-color3"
                  v-b-tooltip.hover="
                    'Delete log. ' +
                      row.item.btr_delete_user_log +
                      ' | ' +
                      thaiDatetimeFc.ThaiDateTime(
                        row.item.btr_delete_user_datetime
                      )
                  "
                ></v-icon>
              </div>
            </template>
          </b-table>
        </b-alert>
      </div>
    </b-alert>
  </div>
</template>

<script>
import { Component, Vue } from "vue-property-decorator";
import feather from "vue-icon";
import store from "@/store/store";
import thaiDatetime from "@/functions/thaiDatetime";
import pjFunctions from "@/functions/pjFunctions";
import DocumentScan from "@/models/patientEMRs/DocumentScan";
import PatientData from "@/models/patientEMRs/PatientData";
import PatientVisit from "@/models/patientEMRs/PatientVisit";
import PatientAdmitData from "@/models/patientEMRs/PatientAdmitData";
import LabBtrChoice from "@/models/patientEMRs/LabBtrChoice";
import LabBtrData from "@/models/patientEMRs/LabBtrData";

Vue.use(feather, "v-icon");

@Component({
  data() {
    return {
      thaiDatetimeFc: null,
      pjFunctionsFc: null,
      TmpDataNHSO: [],
      TmpfieldsNHSO: [],
      PatientDataLoad: null,
      VisitDataLoad: null,
      AdmitDataLoad: null,
      ChoiceBigr: null,
      ChoiceRh: null,
      ChoiceDat: null,
      ChoiceIat: null,
      ChoiceSymptom: null,
      ChoiceCrossMatching: null,
      selectedCheckboxSymptom: [],
      btr_id: "",
      DonorNo: "",
      BiGrSelected: "",
      BiGrL1Selected: "",
      BiGrL2Selected: "",
      RhSelected: "",
      RhL1Selected: "",
      RhL2Selected: "",
      DatL1Selected: "",
      DatL2Selected: "",
      IatL1Selected: "",
      IatL2Selected: "",
      NoteL1Selected: "",
      NoteL2Selected: "",
      CrossMatchingL1Selected: "",
      CrossMatchingL2Selected: "",
      blood_start_date: new Date(),
      blood_start_time: new Date(),
      blood_stop_date: new Date(),
      blood_stop_time: new Date(),
      temperature_start: "",
      temperature_stop: "",
      bloodValue: "",
      btr_note: "",
      n: ["1", "2"],
      ChoiceSymptomNote: [],
      tbBtrTableData: null,
      tbBtrTableFieldsData: null,
      sortBy: "numbers",
      sortDesc: true,
      SelectDataBTR: null,
      btr_user_log: "",
      btr_cross_matching_user_log: "",
      btr_save_button: true,
      labReceiveStatus: "N",
      btrLabConfirm: "N",
      lang: {
        // days: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
        days: ["อา", "จ", "อ", "พ", "พฤ", "ศ", "ส"],
        months: [
          "ม.ค",
          "ก.พ",
          "มี.ค",
          "เม.ย",
          "พ.ค",
          "มิ.ย",
          "ก.ค",
          "ส.ค",
          "ก.ย",
          "ต.ค",
          "พ.ย",
          "ธ.ค"
        ],
        // months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
        pickers: ["next 1 days", "previous 1 days"],
        placeholder: {
          date: "Select Date",
          dateRange: "Select Date Range"
        }
      }
    };
  },
  props: ["MyVn", "MyHn", "MyAn"],
  component: {
    thaiDatetime,
    pjFunctions,
    PatientData,
    PatientVisit,
    PatientAdmitData,
    LabBtrChoice,
    LabBtrData
  },
  created() {
    this.thaiDatetimeFc = thaiDatetime.methods;
    this.pjFunctionsFc = pjFunctions.methods;
    this.getBtrChoice();
    this.getPatientData(this.MyHn);
    this.getVisitData(this.MyVn);
    if (this.MyAn) {
      this.AdmitDataLoad = null;
      this.setAdmitData(this.MyHn, this.MyAn);
    }

    if (this.MyVn) {
      this.setBTR(this.MyHn, this.MyVn);
    }
  },
  watch: {
    MyHn: function() {
      this.getPatientData(this.MyHn);
    },
    MyVn: function() {
      this.getVisitData(this.MyVn);
      this.setBTR(this.MyHn, this.MyVn);
    },
    MyAn: function() {
      if (this.MyAn) {
        this.AdmitDataLoad = null;
        this.setAdmitData(this.MyHn, this.MyAn);
      }
    }
  },
  computed: {},
  methods: {
    show(group, type = "", title = "", text = "") {
      //const text = `
      //  This is notification text!
      //  <br>
      //  Date: ${new Date()}
      // `
      this.$notify({
        group,
        title: title,
        text: text,
        type,
        data: {
          randomNumber: Math.random()
        }
      });
    },
    clean(group) {
      this.$notify({ group, clean: true });
    },
    submitDeleteBTR(btr_id, action, msgText) {
      let conF = null;
      this.$bvModal
        .msgBoxConfirm(msgText, {
          title: "Please Confirm",
          size: "sm",
          buttonSize: "sm",
          okVariant: "success",
          okTitle: "YES",
          cancelTitle: "NO",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true
        })
        .then(value => {
          conF = value;
          if (conF == true) {
            if (btr_id != "") {
              this.DeleteDataBTR(btr_id, action);
            } else {
              alert("ข้อมูลสำหรับลบไม่เพียงพอ !");
            }
          }
        })
        .catch(err => {
          // An error occurred
        });
    },
    DeleteDataBTR(btr_id, action) {
      if (action == "Delete") {
        let formData = new FormData();
        formData.append("CompanyId", this.$store.get("systems@CompanyId"));
        formData.append("ApiKey", this.$store.get("systems@ApiKey"));
        formData.append("hn", this.MyHn);
        formData.append("vn", this.MyVn);
        formData.append("btr_id", btr_id);

        let ScrObj = this;
        this.axios
          .post(this.$store.get("systems@UrlApi") + "LabBtrDelete", formData)
          .then(function(response) {
            ScrObj.output = response.data;
            if (ScrObj.output.status === true) {
              ScrObj.setBTR(ScrObj.MyHn, ScrObj.MyVn);

              ScrObj.show(
                "notifi-main-top-right",
                "success",
                "Save Data Success",
                "การลบข้อมูลเสร็จสมบูรณ์ ^_^ <br>Date : " +
                  ScrObj.thaiDatetimeFc.ThaiDateTime(
                    ScrObj.thaiDatetimeFc.DateTimeNow()
                  )
              );

              ScrObj.$bvModal.hide("modal-btr");
            } else {
              ScrObj.setBTR(ScrObj.MyHn, ScrObj.MyVn);

              ScrObj.show(
                "notifi-main-top-right",
                "warn",
                "Save Data Error",
                "การลบข้อมูลมีปัญหากรุณาลองใหม่อีกครั้ง ^_^ " +
                  "<br>ErrorMessage : " +
                  ScrObj.output.ErrorMessage +
                  "<br>Date : " +
                  ScrObj.thaiDatetimeFc.ThaiDateTime(
                    ScrObj.thaiDatetimeFc.DateTimeNow()
                  )
              );
            }
          })
          .catch(function(error) {
            ScrObj.output = error;

            ScrObj.setBTR(ScrObj.MyHn, ScrObj.MyVn);

            ScrObj.show(
              "ansn-foo-css",
              "error",
              "Save Data Error",
              "การลบข้อมูลมีปัญหากรุณาลองใหม่อีกครั้ง ^_^ " +
                "<br>ErrorMessage : " +
                ScrObj.output +
                "<br>Date : " +
                ScrObj.thaiDatetimeFc.ThaiDateTime(
                  ScrObj.thaiDatetimeFc.DateTimeNow()
                )
            );

            console.log("LabBtrDelete : " + ScrObj.output);
          });
      }
    },
    selectItemBTR(btr_id, hn, vn) {
      let ScrObj = LabBtrData.query()
        .where(record => record.btr_id == btr_id)
        .where(record => record.hn == hn)
        .where(record => record.vn == vn)
        .get();

      this.selectedCheckboxSymptom = [];

      this.BiGrL1Selected = "";
      this.RhL1Selected = "";
      this.DatL1Selected = "";
      this.IatL1Selected = "";
      this.CrossMatchingL1Selected = "";
      this.NoteL1Selected = "";

      this.BiGrL2Selected = "";
      this.RhL2Selected = "";
      this.DatL2Selected = "";
      this.IatL2Selected = "";
      this.CrossMatchingL2Selected = "";
      this.NoteL2Selected = "";

      if (ScrObj.length > 0) {
        this.SelectDataBTR = ScrObj[0];
        this.btr_id = this.SelectDataBTR.datas.btrMain.btr_id;
        this.DonorNo = this.SelectDataBTR.datas.btrMain.donor_no;
        this.BiGrSelected = this.SelectDataBTR.datas.btrMain.donor_bi_gr;
        this.RhSelected = this.SelectDataBTR.datas.btrMain.donor_rh;
        this.blood_start_date = this.thaiDatetimeFc.StrToDate(
          this.SelectDataBTR.datas.btrMain.transfusion_start_date +
            " " +
            this.SelectDataBTR.datas.btrMain.transfusion_start_time
        );
        this.blood_start_time = this.thaiDatetimeFc.StrToDate(
          this.SelectDataBTR.datas.btrMain.transfusion_start_date +
            " " +
            this.SelectDataBTR.datas.btrMain.transfusion_start_time
        );

        this.blood_stop_date = this.thaiDatetimeFc.StrToDate(
          this.SelectDataBTR.datas.btrMain.symptom_start_date +
            " " +
            this.SelectDataBTR.datas.btrMain.symptom_start_time
        );
        this.blood_stop_time = this.thaiDatetimeFc.StrToDate(
          this.SelectDataBTR.datas.btrMain.symptom_start_date +
            " " +
            this.SelectDataBTR.datas.btrMain.symptom_start_time
        );

        this.temperature_start = this.SelectDataBTR.datas.btrMain.temperature_before_transfusion;
        this.temperature_stop = this.SelectDataBTR.datas.btrMain.temperature_after_transfusion;

        this.bloodValue = this.SelectDataBTR.datas.btrMain.transfusion_blood_volume;
        this.btr_note = this.SelectDataBTR.datas.btrMain.btr_note;

        this.btr_user_log =
          this.SelectDataBTR.datas.btrMain.btr_edit_user_log +
          " | " +
          this.thaiDatetimeFc.ThaiDateTime(
            this.SelectDataBTR.datas.btrMain.btr_edit_user_datetime
          );

        this.btr_cross_matching_user_log =
          this.SelectDataBTR.datas.btrMain.lab_cross_matching_user +
          " | " +
          this.thaiDatetimeFc.ThaiDateTime(
            this.SelectDataBTR.datas.btrMain.lab_cross_matching_datetime
          );

        for (let val of this.SelectDataBTR.datas.btrSymptomList) {
          this.selectedCheckboxSymptom.push(val.btr_symptom_id);
        }

        for (let val2 of this.ChoiceSymptom) {
          let DbData = this.SelectDataBTR.datas.btrSymptomList.find(
            element => element.btr_symptom_id == val2.value
          );
          if (DbData) {
            val2.other_text = DbData.btr_symptom_other;
          } else {
            val2.other_text = "";
          }
        }

        this.labReceiveStatus = this.SelectDataBTR.datas.btrMain.lab_receive_status;
        this.btrLabConfirm = this.SelectDataBTR.datas.btrMain.lab_cross_matching_status;

        for (let val3 of this.SelectDataBTR.datas.btrLab) {
          if (val3.btr_lab_time == "1") {
            this.BiGrL1Selected = val3.btr_lab_bi_gr;
            this.RhL1Selected = val3.btr_lab_rh;
            this.DatL1Selected = val3.btr_lab_dat;
            this.IatL1Selected = val3.btr_lab_iat;
            this.CrossMatchingL1Selected = val3.btr_lab_cross_matching;
            this.NoteL1Selected = val3.btr_lab_note;
          }
          if (val3.btr_lab_time == "2") {
            this.BiGrL2Selected = val3.btr_lab_bi_gr;
            this.RhL2Selected = val3.btr_lab_rh;
            this.DatL2Selected = val3.btr_lab_dat;
            this.IatL2Selected = val3.btr_lab_iat;
            this.CrossMatchingL2Selected = val3.btr_lab_cross_matching;
            this.NoteL2Selected = val3.btr_lab_note;
          }
        }

        if (this.SelectDataBTR.datas.btrMain.lab_receive_status == "Y") {
          this.btr_save_button = false;
        } else {
          this.btr_save_button = true;
        }
      } else {
        this.SelectDataBTR = null;
        this.btr_id = btr_id;
        this.DonorNo = "";
        this.BiGrSelected = "";
        this.RhSelected = "";
        this.blood_start_date = new Date();
        this.blood_start_time = new Date();

        this.blood_stop_date = new Date();
        this.blood_stop_time = new Date();

        this.temperature_start = "";
        this.temperature_stop = "";

        this.bloodValue = "";
        this.btr_note = "";
        this.btr_user_log = "";
        this.btr_cross_matching_user_log = "";

        this.selectedCheckboxSymptom = [];

        for (let val2 of this.ChoiceSymptom) {
          val2.other_text = "";
        }

        this.BiGrL1Selected = "";
        this.RhL1Selected = "";
        this.DatL1Selected = "";
        this.IatL1Selected = "";
        this.CrossMatchingL1Selected = "";
        this.NoteL1Selected = "";

        this.BiGrL2Selected = "";
        this.RhL2Selected = "";
        this.DatL2Selected = "";
        this.IatL2Selected = "";
        this.CrossMatchingL2Selected = "";
        this.NoteL2Selected = "";

        this.labReceiveStatus = "N";
        this.btrLabConfirm = "N";

        this.btr_save_button = true;
      }

      this.$bvModal.show("modal-btr");
    },
    submitBTR(hn, action, msgText) {
      let conF = null;
      this.$bvModal
        .msgBoxConfirm(msgText, {
          title: "Please Confirm",
          size: "sm",
          buttonSize: "sm",
          okVariant: "success",
          okTitle: "YES",
          cancelTitle: "NO",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true
        })
        .then(value => {
          conF = value;
          if (conF == true) {
            if (
              hn != "" &&
              this.DonorNo != "" &&
              this.BiGrSelected != "" &&
              this.RhSelected != "" &&
              this.blood_start_date != "" &&
              this.blood_start_time != "" &&
              this.blood_stop_date != "" &&
              this.blood_stop_time != "" &&
              this.temperature_start != "" &&
              this.temperature_stop != "" &&
              this.bloodValue != ""
            ) {
              this.saveLabAndBTR(hn, action);
            } else {
              alert(
                "กรุณากรอกข้อมูลที่กำหนด \n-Donor No, \n-BI. Gr, \n-Rh, \n-เวลาเริ่มให้เลือด, \n-เวลาที่เกิดอาการ, \n-อุณหภูมิก่อนให้เลือด, \n-อุณหภูมิเมื่อหยุดให้เลือด, \n-ปริมาณเลือดที่ให้"
              );
            }
          }
        })
        .catch(err => {
          // An error occurred
        });
    },
    saveLabAndBTR(hn, action) {
      if (action == "saveBTR") {
        let department = "";
        let department_name = "";
        let visit_type = "";

        if (!this.AdmitDataLoad) {
          department = this.VisitDataLoad.datas.department_code;
          department_name = this.VisitDataLoad.datas.department_name;
          visit_type = "OPD";
        } else {
          department = this.AdmitDataLoad.datas.ward;
          department_name = this.AdmitDataLoad.datas.ward_name;
          visit_type = "IPD";
        }

        let formData = new FormData();
        formData.append("CompanyId", this.$store.get("systems@CompanyId"));
        formData.append("ApiKey", this.$store.get("systems@ApiKey"));
        formData.append("hn", hn);
        formData.append("vn", this.MyVn);
        formData.append("an", this.MyAn);
        formData.append("btr_id", this.btr_id);
        formData.append("visit_type", visit_type);
        formData.append("department", department);
        formData.append("department_name", department_name);
        formData.append("bi_gr", this.BiGrSelected);
        formData.append("rh", this.RhSelected);
        formData.append("donor_no", this.DonorNo);
        formData.append("donor_bi_gr", this.BiGrSelected);
        formData.append("donor_rh", this.RhSelected);

        formData.append(
          "transfusion_start_date",
          this.thaiDatetimeFc.DateTimeToStrDate(this.blood_start_date)
        );

        formData.append(
          "transfusion_start_time",
          this.thaiDatetimeFc.DateTimeToStrTime(this.blood_start_time)
        );

        formData.append(
          "symptom_start_date",
          this.thaiDatetimeFc.DateTimeToStrDate(this.blood_stop_date)
        );
        formData.append(
          "symptom_start_time",
          this.thaiDatetimeFc.DateTimeToStrTime(this.blood_stop_time)
        );

        formData.append(
          "temperature_before_transfusion",
          this.temperature_start
        );
        formData.append("temperature_after_transfusion", this.temperature_stop);
        formData.append("transfusion_blood_volume", this.bloodValue);

        let SymptomNoteList = [];

        for (let val1 of this.selectedCheckboxSymptom) {
          let ll = this.pjFunctionsFc.SymptomArrayfilter(
            this.ChoiceSymptom,
            val1
          );

          SymptomNoteList.push(ll[0]);
        }

        formData.append("symptom_list", JSON.stringify(SymptomNoteList));

        formData.append("btr_note", this.btr_note);

        let ScrObj = this;
        this.axios
          .post(this.$store.get("systems@UrlApi") + "LabBtrSave", formData)
          .then(function(response) {
            ScrObj.output = response.data;
            if (ScrObj.output.status === true) {
              ScrObj.setBTR(ScrObj.MyHn, ScrObj.MyVn);

              ScrObj.show(
                "notifi-main-top-right",
                "success",
                "Save Data Success",
                "การบันทึกข้อมูลเสร็จสมบูรณ์ ^_^ <br>Date : " +
                  ScrObj.thaiDatetimeFc.ThaiDateTime(
                    ScrObj.thaiDatetimeFc.DateTimeNow()
                  )
              );

              ScrObj.$bvModal.hide("modal-btr");
            } else {
              ScrObj.setBTR(ScrObj.MyHn, ScrObj.MyVn);

              ScrObj.show(
                "notifi-main-top-right",
                "warn",
                "Save Data Error",
                "การบันทึกข้อมูลมีปัญหากรุณาลองใหม่อีกครั้ง ^_^ " +
                  "<br>ErrorMessage : " +
                  ScrObj.output.ErrorMessage +
                  "<br>Date : " +
                  ScrObj.thaiDatetimeFc.ThaiDateTime(
                    ScrObj.thaiDatetimeFc.DateTimeNow()
                  )
              );
            }
          })
          .catch(function(error) {
            ScrObj.output = error;

            ScrObj.setBTR(ScrObj.MyHn, ScrObj.MyVn);

            ScrObj.show(
              "ansn-foo-css",
              "error",
              "Save Data Error",
              "การบันทึกข้อมูลมีปัญหากรุณาลองใหม่อีกครั้ง ^_^ " +
                "<br>ErrorMessage : " +
                ScrObj.output +
                "<br>Date : " +
                ScrObj.thaiDatetimeFc.ThaiDateTime(
                  ScrObj.thaiDatetimeFc.DateTimeNow()
                )
            );

            console.log("LabBtrSave : " + ScrObj.output);
          });
      }
    },
    setBTR(hn, vn) {
      let data = [];

      /** LabBtrData */
      let DataObj = this;
      this.axios
        .post(this.$store.get("systems@UrlApi") + "LabBtrData", {
          CompanyId: this.$store.get("systems@CompanyId"),
          ApiKey: this.$store.get("systems@ApiKey"),
          hn: hn,
          vn: vn
        })
        .then(function(response) {
          DataObj.output = response.data;
          if (DataObj.output.status === true) {
            LabBtrData.delete({
              where(record) {
                return record.vn == vn;
              }
            });

            data = [];
            for (var val of DataObj.output.result) {
              data.push({
                id: val.btrMain.btr_id,
                btr_id: val.btrMain.btr_id,
                hn: val.btrMain.hn,
                vn: val.btrMain.vn,
                an: val.btrMain.an,
                ptName:
                  val.btrMain.pname +
                  val.btrMain.fname +
                  " " +
                  val.btrMain.lname,
                transfusion_start_date: val.btrMain.transfusion_start_date,
                transfusion_start_time: val.btrMain.symptom_start_date,
                symptom_start_date: val.btrMain.symptom_start_date,
                symptom_start_time: val.btrMain.symptom_start_time,
                lab_receive_status: val.btrMain.lab_receive_status,
                lab_cross_matching_status:
                  val.btrMain.lab_cross_matching_status,
                btr_status: val.btrMain.btr_status,
                datas: val,
                list_orderby: val.btrMain.list_orderby
              });
            }

            LabBtrData.insertOrUpdate({
              data
            });
          } else {
            if (DataObj.output.ErrorMessage === "Data Not Found") {
              LabBtrData.delete({
                where(record) {
                  return record.vn == vn;
                }
              });
            }
          }
        })
        .catch(function(error) {
          DataObj.output = error;
          console.log("LabBtrData : " + DataObj.output);
        })
        .finally(function() {
          DataObj.LoadTableBTR(hn, vn);
        });

      // DataObj.LoadTableBTR(hn, vn);
    },
    LoadTableBTR(hn, vn) {
      let ScrObj = LabBtrData.query()
        .where(record => record.hn == hn)
        .where(record => record.vn == vn)
        .orderBy("list_orderby")
        .get();

      let BtrTableData = [];

      for (let i = 0; i < ScrObj.length; i++) {
        BtrTableData.push({
          numbers: i + 1,
          btr_id: ScrObj[i].datas.btrMain.btr_id,
          hn: ScrObj[i].datas.btrMain.hn,
          vn: ScrObj[i].datas.btrMain.vn,
          an: ScrObj[i].datas.btrMain.an,
          ptName:
            ScrObj[i].datas.btrMain.pname +
            ScrObj[i].datas.btrMain.fname +
            " " +
            ScrObj[i].datas.btrMain.lname,
          donor_no: ScrObj[i].datas.btrMain.donor_no,
          transfusion_start_datetime: this.thaiDatetimeFc.ThaiDateTime(
            ScrObj[i].datas.btrMain.transfusion_start_date +
              " " +
              ScrObj[i].datas.btrMain.transfusion_start_time
          ),
          symptom_start_datetime: this.thaiDatetimeFc.ThaiDateTime(
            ScrObj[i].datas.btrMain.symptom_start_date +
              " " +
              ScrObj[i].datas.btrMain.symptom_start_time
          ),
          lab_receive_status: ScrObj[i].datas.btrMain.lab_receive_status,
          lab_receive_datetime: ScrObj[i].datas.btrMain.lab_receive_datetime,
          lab_cross_matching_status:
            ScrObj[i].datas.btrMain.lab_cross_matching_status,
          lab_cross_matching_datetime:
            ScrObj[i].datas.btrMain.lab_cross_matching_datetime,
          btr_delete_user_log: ScrObj[i].datas.btrMain.btr_delete_user_log,
          btr_delete_user_datetime:
            ScrObj[i].datas.btrMain.btr_delete_user_datetime,
          btr_status: ScrObj[i].datas.btrMain.btr_status
        });
      }

      let BtrTableFieldsData = [
        { label: "ลำดับ", key: "numbers", sortable: true, class: "text-right" },
        { label: "Donor No", key: "donor_no", sortable: true },
        {
          label: "เวลาเริ่มให้เลือด",
          key: "transfusion_start_datetime",
          sortable: true
        },
        {
          label: "เวลาที่เกิดอาการ",
          key: "symptom_start_datetime",
          sortable: true
        },
        {
          label: "Lab Receive",
          key: "lab_receive_status",
          class: "text-center"
        },
        {
          label: "Cross Matching",
          key: "lab_cross_matching_status",
          sortable: true,
          formatter: (value, key, item) => {
            return value == "Y" ? "Yes" : "No";
          },
          class: "text-center"
        },
        { label: "Views", key: "actions", class: "text-center" }
      ];

      if (ScrObj.length > 0) {
        this.tbBtrTableData = BtrTableData;
        this.tbBtrTableFieldsData = BtrTableFieldsData;
      } else {
        this.tbBtrTableData = null;
        this.tbBtrTableFieldsData = null;
      }
    },
    setAdmitData(hn, an) {
      let data = [];

      /** Admit Data Load */
      let DataObj = this;
      this.axios
        .post(this.$store.get("systems@UrlApi") + "AdmitData", {
          CompanyId: this.$store.get("systems@CompanyId"),
          ApiKey: this.$store.get("systems@ApiKey"),
          hn: hn,
          an: an
        })
        .then(function(response) {
          DataObj.output = response.data;
          if (DataObj.output.status === true) {
            PatientAdmitData.delete({
              where(record) {
                return record.an == an;
              }
            });

            data = [];
            for (var val of DataObj.output.result) {
              data.push({
                id: val.an,
                an: val.an,
                hn: val.hn,
                vn: val.vn,
                datas: val
              });
            }

            PatientAdmitData.insertOrUpdate({
              data
            });
          } else {
            if (DataObj.output.ErrorMessage === "Data Not Found") {
              PatientAdmitData.delete({
                where(record) {
                  return record.an == an;
                }
              });
            }
          }
        })
        .catch(function(error) {
          DataObj.output = error;
          console.log("AdmitData : " + DataObj.output);
        })
        .finally(function() {
          DataObj.getAdmitData(hn, an);
        });
    },
    getPatientData(hn) {
      let ptData2 = PatientData.query()
        .where(record => record.datas.hn == hn)
        .get();

      if (ptData2.length > 0) {
        this.PatientDataLoad = ptData2[0];
      }
    },
    getVisitData(vn) {
      let VisitData = PatientVisit.query()
        .where(record => record.datas.vn == vn)
        .get();

      if (VisitData.length > 0) {
        this.VisitDataLoad = VisitData[0];
      }
    },
    getAdmitData(hn, an) {
      let DataObj = PatientAdmitData.query()
        .where(record => record.datas.hn == hn)
        .where(record => record.datas.an == an)
        .get();
      if (DataObj.length > 0) {
        this.AdmitDataLoad = DataObj[0];
      }
    },
    getBtrChoice() {
      let DataObj = [];
      DataObj = LabBtrChoice.query()
        .where(record => record.datas.btr_choice_type == "BI.Gr")
        .where(record => record.btr_choice_status == "Y")
        .orderBy("list_orderby")
        .get();
      if (DataObj.length > 0) {
        let data = [];
        data.push({
          value: "",
          text: ".:: BI. Gr ::."
        });
        for (let val of DataObj) {
          data.push({
            value: val.id,
            text: val.datas.btr_choice_name
          });
        }
        this.ChoiceBigr = data;
      } else {
        this.ChoiceBigr = null;
      }

      DataObj = LabBtrChoice.query()
        .where(record => record.datas.btr_choice_type == "Rh")
        .where(record => record.btr_choice_status == "Y")
        .orderBy("list_orderby")
        .get();
      if (DataObj.length > 0) {
        let data = [];
        data.push({
          value: "",
          text: ".:: Rh ::."
        });
        for (let val of DataObj) {
          data.push({
            value: val.id,
            text: val.datas.btr_choice_name
          });
        }
        this.ChoiceRh = data;
      } else {
        this.ChoiceRh = null;
      }

      DataObj = LabBtrChoice.query()
        .where(record => record.datas.btr_choice_type == "Symptom")
        .where(record => record.btr_choice_status == "Y")
        .orderBy("list_orderby")
        .get();
      if (DataObj.length > 0) {
        let data = [];

        for (let val of DataObj) {
          data.push({
            value: val.id,
            text: val.datas.btr_choice_name,
            other: val.datas.btr_choice_other,
            other_text: ""
          });
        }
        this.ChoiceSymptom = data;
      } else {
        this.ChoiceSymptom = null;
      }

      DataObj = LabBtrChoice.query()
        .where(record => record.datas.btr_choice_type == "DAT")
        .where(record => record.btr_choice_status == "Y")
        .orderBy("list_orderby")
        .get();
      if (DataObj.length > 0) {
        let data = [];
        data.push({
          value: "",
          text: ".:: DAT ::."
        });
        for (let val of DataObj) {
          data.push({
            value: val.id,
            text: val.datas.btr_choice_name,
            other: val.datas.btr_choice_other,
            other_text: ""
          });
        }
        this.ChoiceDat = data;
      } else {
        this.ChoiceDat = null;
      }

      DataObj = LabBtrChoice.query()
        .where(record => record.datas.btr_choice_type == "IAT")
        .where(record => record.btr_choice_status == "Y")
        .orderBy("list_orderby")
        .get();
      if (DataObj.length > 0) {
        let data = [];
        data.push({
          value: "",
          text: ".:: IAT ::."
        });
        for (let val of DataObj) {
          data.push({
            value: val.id,
            text: val.datas.btr_choice_name,
            other: val.datas.btr_choice_other,
            other_text: ""
          });
        }
        this.ChoiceIat = data;
      } else {
        this.ChoiceIat = null;
      }

      DataObj = LabBtrChoice.query()
        .where(record => record.datas.btr_choice_type == "CrossMatching")
        .where(record => record.btr_choice_status == "Y")
        .orderBy("list_orderby")
        .get();
      if (DataObj.length > 0) {
        let data = [];
        data.push({
          value: "",
          text: ".:: Cross Matching ::."
        });
        for (let val of DataObj) {
          data.push({
            value: val.id,
            text: val.datas.btr_choice_name,
            other: val.datas.btr_choice_other,
            other_text: ""
          });
        }
        this.ChoiceCrossMatching = data;
      } else {
        this.ChoiceCrossMatching = null;
      }
    }
  }
})
export default class EmrReportBTR extends Vue {}
</script>

<style lang="scss">
.alert {
  margin-bottom: 0px !important;
}

.checkbox-symptom-custom {
  margin-right: 0px !important;
  margin-left: 0px !important;
}

.margin-bottom-0 {
  margin-bottom: 0px !important;
}

.form-group {
  margin-bottom: 8px !important;
}

.icon-css {
  margin-right: 4px;
  float: left;
}
</style>

